import { Action } from '@ngrx/store';
import { IMemberProfileAddress } from '@shared/shared/interfaces/member-profile-address.interfaces';

// Create address
export const CREATE_PROFILE_ADDRESS = '[Member Profile] Create Profile Address';
export const CREATE_PROFILE_ADDRESS_SUCCESS = '[Member Profile] Create Profile Address Success';
export const CREATE_PROFILE_ADDRESS_FAIL = '[Member Profile] Create Profile Address Fail';

export class CreateProfileAddress implements Action {
  readonly type = CREATE_PROFILE_ADDRESS;
  constructor(public payload: IMemberProfileAddress) {}
}

export class CreateProfileAddressSuccess implements Action {
  readonly type = CREATE_PROFILE_ADDRESS_SUCCESS;
  constructor(public payload: IMemberProfileAddress) {}
}

export class CreateProfileAddressFail implements Action {
  readonly type = CREATE_PROFILE_ADDRESS_FAIL;
}

// Destroy address
export const DESTROY_PROFILE_ADDRESS = '[Member Profile] Destroy Profile Address';
export const DESTROY_PROFILE_ADDRESS_SUCCESS = '[Member Profile] Destroy Profile Address Success';
export const DESTROY_PROFILE_ADDRESS_FAIL = '[Member Profile] Destroy Profile Address Fail';

export class DestroyProfileAddress implements Action {
  readonly type = DESTROY_PROFILE_ADDRESS;
  constructor(public payload: number) {}
}

export class DestroyProfileAddressSuccess implements Action {
  readonly type = DESTROY_PROFILE_ADDRESS_SUCCESS;
  constructor(public payload: number) {}
}

export class DestroyProfileAddressFail implements Action {
  readonly type = DESTROY_PROFILE_ADDRESS_FAIL;
}

// Update address
export const UPDATE_PROFILE_ADDRESS = '[Member Profile] Update Profile Address';
export const UPDATE_PROFILE_ADDRESS_SUCCESS = '[Member Profile] Update Profile Address Success';
export const UPDATE_PROFILE_ADDRESS_FAIL = '[Member Profile] Update Profile Address Fail';

export class UpdateProfileAddress implements Action {
  readonly type = UPDATE_PROFILE_ADDRESS;
  constructor(public payload: any) {}
}

export class UpdateProfileAddressSuccess implements Action {
  readonly type = UPDATE_PROFILE_ADDRESS_SUCCESS;
  constructor(public payload: IMemberProfileAddress) {}
}

export class UpdateProfileAddressFail implements Action {
  readonly type = UPDATE_PROFILE_ADDRESS_FAIL;
}

export type MemberProfileAddressAction =
  | CreateProfileAddress
  | CreateProfileAddressSuccess
  | CreateProfileAddressFail
  | DestroyProfileAddress
  | DestroyProfileAddressSuccess
  | DestroyProfileAddressFail
  | UpdateProfileAddress
  | UpdateProfileAddressSuccess
  | UpdateProfileAddressFail;
